<template>
  <header>
    <div>
      <a href="/#/">
        <img
          align="left"
          src="../assets/logo-2.png"
          class="logo d-block d-lg-none"
        />
      </a>
    </div>

    <div class="titlelocation d-none d-lg-block">
      <span class="titlechanges underlinetitle">S</span>
      <a href="/#/" style="color: inherit; text-decoration: none">
        <span
          class="titlechanges"
          v-on:mouseleave="titlechange = 'ani Coaching'"
          v-on:mouseover="TitleSentenceMouseOver()"
          >h{{ titlechange }}</span
        >
      </a>
    </div>
  </header>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      lastArrayIndex: -1,
      titleOptions: [
        "ine bright like a diamond",
        "ine your light",
        "are your gift",
        "ow up",
        "ow them what you've got",
        "alalala",
      ],
      titlechange: "ani Coaching",
    };
  },
  methods: {
    getRandomInt(max) {
      let index = Math.floor(Math.random() * Math.floor(max));
      while (this.lastArrayIndex == index)
        index = Math.floor(Math.random() * Math.floor(max));
      return index;
    },
    TitleSentenceMouseOver() {
      let arrayIndex = this.getRandomInt(this.titleOptions.length);
      this.lastArrayIndex = arrayIndex;
      this.titlechange = this.titleOptions[arrayIndex];
    },
  },
};
</script>

<style scoped lang="scss">
header {
  padding: 10px 25px;
}
.logo {
  margin: 12px 0;
  width: 12em;
  height: auto;
}
.titlelocation {
  text-align: left;
  height: auto;
}
.titlechanges {
  font-size: 2em;
  width: 11em;
  text-align: left;
}
.underlinetitle {
  border-bottom: 2px solid #000;
}
</style>
